import { formatDateFullFormat, formatDatePartialFormat } from '@widergy/web-utils/lib/date';
import { objectIsEmpty } from '@widergy/web-utils/lib/object';

import numeral from 'config/numeral';
import { consumptionUnit } from 'constants/units';

export const billSelector = (currentBill, bill, consumptionHistory) => {
  const searchedBill =
    consumptionHistory &&
    consumptionHistory.bills.find(_bill => _bill.external_id === currentBill.external_id);
  const billID = searchedBill && searchedBill.id;
  return (
    !objectIsEmpty(currentBill) && {
      id: currentBill.id || billID,
      external_id: currentBill.external_id,
      downloadable: currentBill.downloadable,
      period_started_on: formatDateFullFormat(currentBill.period_started_on),
      period_ended_on: formatDateFullFormat(currentBill.period_ended_on),
      period: `${formatDatePartialFormat(
        typeof currentBill.period === 'string' ? currentBill.period : `${currentBill.period}`
      )}`,
      issued_on: formatDateFullFormat(currentBill.issued_on),
      consumption: `${numeral(currentBill.consumption).format()} ${consumptionUnit}`,
      first_expiration_on: formatDateFullFormat(currentBill.first_expiration_on),
      second_expiration_on: formatDateFullFormat(currentBill.second_expiration_on),
      amount: numeral(currentBill.amount).format('$0,0.[00]'),
      surcharge_amount:
        currentBill.surcharge_amount && numeral(currentBill.surcharge_amount).format('$0,0.[00]'),
      printedBill: bill && bill.printedBill
    }
  );
};
